import BIPage from "../components/pages/buyingIntelligence/BIPage";
import BIOverviewPage from "../components/pages/buyingIntelligence/BIOverviewPage.jsx";
import BIBuyPlan from "../components/pages/buyingIntelligence/BIBuyPlan.jsx";
import BIAddPage from "../components/pages/buyingIntelligence/BIAddPage.jsx";

const routes = [
    {
        path: "/buying-intel",
        element: <BIPage />
    },
    {
        path: "/buying-intel/add",
        element: <BIAddPage />
    },
    {
        path: "/buying-intel/overview",
        element: <BIOverviewPage />
    },
    {
        path: "/buying-intel/overview/:buyingCycleID",
        element: <BIOverviewPage />
    },
    {
        path: "/buying-intel/buyplan",
        element: <BIBuyPlan />
    },
    {
        path: "/buying-intel/buyplan/:buyingCycleID",
        element: <BIBuyPlan />
    }
    /*
    {
        path: "/buying-intel/order/:buyingCycleID",
        element: <BIOrderPage />
    },
    {
        path: "/buying-intel/forecast/:buyingCycleID",
        element: <BIForecastPage />
    }
    */
];

export default routes;
